import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Number$parseFloat from "@babel/runtime-corejs3/core-js/number/parse-float";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/ends-with";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import numeral from "numeral";
import i18n from "@Shared/@i18n/";
const getMoneyFormatWithSymbol = formatType => i18n.locale === "fr-CA" ? `${formatType}$` : `$${formatType}`;
export const formatMoneyValue = value => {
  var _context;
  let cleanString = typeof value == "string" && _includesInstanceProperty(value).call(value, "$") ? value.replace("$", "").replace(/,/g, "") : value;
  const floatValue = _Number$parseFloat(cleanString);
  const numeralValue = numeral(floatValue).format("0.00a");
  const isPointZero = _endsWithInstanceProperty(_context = String(numeralValue)).call(_context, ".00") || value == 0;
  const formatType = isPointZero ? "0a" : "0.00a";
  return numeral(floatValue).format(getMoneyFormatWithSymbol(formatType));
};
export const formatMoneyValueLong = (value, withSymbol = true) => {
  const floatValue = _Number$parseFloat(value);
  const format = "0,0.00";
  return numeral(floatValue).format(withSymbol ? getMoneyFormatWithSymbol(format) : format);
};
export const formatIntegerQuantity = value => {
  const parsed = _parseInt(value);
  return numeral(parsed).format("0,0");
};
export const sumMoneyShort = (a, b) => {
  const sum = _parseInt(a) + _parseInt(b);
  const floatValue = _Number$parseFloat(sum);
  return numeral(floatValue).format(getMoneyFormatWithSymbol("0a"));
};
export const sumMoney = (a, b) => {
  const sum = numeral(a).add(numeral(b).value());
  const format = sum.format("0,0.00");
  return format;
};
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("formatMoneyValue", formatMoneyValue);
  // TODO REFACTOR TO RECEIVE FORMAT PARAM
  Handlebars.registerHelper("formatMoneyValueLong", formatMoneyValueLong);
  Handlebars.registerHelper("sumMoneyShort", sumMoneyShort);
  Handlebars.registerHelper("sumMoney", sumMoney);
};